
export default {
    name: 'CrowdfundPress',
    computed: {
        press() {
            return [
                {
                    src: '/images/press/bbc.svg',
                    alt: 'BBC News',
                },
                {
                    src: '/images/press/mail.svg',
                    alt: 'Mail Online',
                },
                {
                    src: '/images/press/itv.svg',
                    alt: 'ITV News',
                },
                {
                    src: '/images/press/dailymirror.svg',
                    alt: 'Daily Mirror',
                },
                {
                    src: '/images/press/evening-standard.svg',
                    alt: 'Evening Standard',
                },
                {
                    src: '/images/press/5news.svg',
                    alt: 'Channel 5',
                },
                {
                    src: '/images/press/telegraph.svg',
                    alt: 'The Telegraph',
                },
                {
                    src: '/images/press/sun.svg',
                    alt: 'The Sun',
                },
                {
                    src: '/images/press/express.svg',
                    alt: 'Daily Express',
                },
                {
                    src: '/images/press/guardian.svg',
                    alt: 'The Guardian',
                },
                {
                    src: '/images/press/times.svg',
                    alt: 'The Times',
                },
                {
                    src: '/images/press/sky.svg',
                    alt: 'Sky News',
                },
            ];
        },
    },
};
